import { encode } from "uqr";
import { useMemo } from "react";

export type QrCodeProps = {
  /** What the code holds (an `otpauth://` URI, a link). */
  value: string;
  /** Rendered width and height in px (default 176). */
  size?: number;
  /** Read by screen readers ("QR code for your authenticator app"). */
  label: string;
  testID?: string;
};

/**
 * A QR code (two-step setup, "scan with your phone"), drawn with uqr. Always dark modules on white with a 4-module
 * quiet zone, in light and dark mode alike, like Google's and Slack's setup screens: inverted codes don't scan in
 * every authenticator app. Native: CoreImage CIQRCodeGenerator (iOS) / ZXing (Android) with the same colours.
 */
export function QrCode({ value, size = 176, label, testID }: QrCodeProps) {
  const { path, n } = useMemo(() => {
    const qr = encode(value, { ecc: "M", border: 4 });
    let d = "";
    qr.data.forEach((row, y) =>
      row.forEach((on, x) => {
        if (on) d += `M${x} ${y}h1v1h-1z`;
      }),
    );
    return { path: d, n: qr.size };
  }, [value]);
  return (
    <svg role="img" aria-label={label} width={size} height={size} viewBox={`0 0 ${n} ${n}`} shapeRendering="crispEdges" data-testid={testID} style={{ borderRadius: 8, flexShrink: 0 }}>
      <rect width={n} height={n} fill="#FFFFFF" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
